import { Option } from '../data';

export type AppointmentTypeSelection = {
  id: number;
  kind: 'appointment' | 'blocker';
};

export const AppointmentTypeSelectionNullObject: AppointmentTypeSelection = Object.freeze({
  id: -1,
  kind: 'appointment',
});

export type AppointmentReducerState = {
  appointmentType: AppointmentTypeSelection;
  branch: number;
  createNewWorkflowInstance: boolean;
  endDate?: Date;
  isBinding: boolean;
  note: string;
  partner?: number;
  people: Option[];
  startDate?: Date;
  teams?: Option[];
  workOrder: number;
};

export type AppointmentFormErrors = {
  appointmentType?: string | null;
  branch?: string | null;
  endDate?: string | null;
  fromTime?: string | null;
  isBinding?: string | null;
  note?: string | null;
  partner?: string | null;
  people?: string | null;
  startDate?: string | null;
  teams?: string | null;
  toTime?: string | null;
  workOrder?: string | null;
};

export enum AppointmentType {
  Feiertag = 'Feiertag',
  VorOrtTerminWP = 'WP - Vor-Ort-Termin',
  WarenanlieferungWP = 'WP - Warenanlieferung',
  VorarbeitMontageWP = 'WP - Vorarbeit Montage',
  MontageWP = 'WP - Montage',
  NachbesserungWP = 'WP - Nachbesserung',
  ZaehlerSetzungstermin = 'Zählersetzungstermin',
  ACInstallation = 'AC Installation',
  ACMontageterminXXX = 'AC-Montagetermin XXX',
  Puffertag = 'Puffertag',
  GeruestAufbau = 'Gerüstaufbau',
  GeruestAbbau = 'Gerüstabbau',
  Warenlieferung = 'Warenlieferung',
  Schulung = 'Schulung',
  KickoffCall = 'Kickoff Call',
  ACMontageterminVerlaengert = 'AC-Montagetermin (verlängert)',
  ACNachbesserungsterminAGVerschuldet = 'AC-Nachbesserungstermin (AG-verschuldet)',
  ACNachbesserungsterminInSeVerschuldet = 'AC-Nachbesserungstermin (InSe-verschuldet)',
  ACNachbesserungsterminKundeVerschuldet = 'AC-Nachbesserungstermin (Kunde-verschuldet)',
  DCMontageterminVerlaengert = 'DC-Montagetermin (verlängert)',
  DCNachbesserungsterminAGVerschuldet = 'DC-Nachbesserungstermin (AG-verschuldet)',
  DCNachbesserungsterminInSeVerschuldet = 'DC-Nachbesserungstermin (InSe-verschuldet)',
  DCNachbesserungsterminKundeVerschuldet = 'DC-Nachbesserungstermin (Kunde-verschuldet)',
  Urlaub = 'Urlaub',
  ACMontagetermin = 'AC-Montagetermin',
  DCMontagetermin = 'DC-Montagetermin',
  VorOrtTermin = 'Vor-Ort-Termin',
  Krank = 'Krank',
  BueroTag = 'Bürotag',
  OnlineBegehung = 'Online-Begehung',
  B2BVorOrtTermin = 'B2B Vor-Ort-Termin',
  B2BBaustellenbegehung = 'B2B Baustellenbegehung',
  B2BACAbnahme = 'B2B AC Abnahme',
  B2BDCAbnahme = 'B2B DC Abnahme',
}
